import type { RestoreConfirmationInput, RestoreData } from '@sb/feathers-types';

import { getService } from '../utils';

/**
 * Answer the pending restore. `confirm` is the consent that lets updater-bot
 * wipe and re-apply the box, so it always carries the command id the
 * operator was actually shown — feathers-bot rejects it against anything
 * else.
 */
export async function submitRestoreDecision(
  input: RestoreConfirmationInput,
): Promise<void> {
  // The service's read shape and its create payload are different types,
  // and Feathers v4's Service<T> only models one of them.
  await getService('restore')().create(
    input as unknown as Partial<RestoreData>,
  );
}
